
/* styles */
require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-37f216ac!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./InquiryDetails.vue")
require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-37f216ac&scoped=true!../../../node_modules/vue-loader/lib/selector?type=styles&index=1!./InquiryDetails.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./InquiryDetails.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-37f216ac!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./InquiryDetails.vue"),
  /* scopeId */
  "data-v-37f216ac",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/pages/orderManagement/InquiryDetails.vue
// module id = 1530
// module chunks = 3